/**
 * 表紙特集掲載商品選定（バイヤー）画面の選定商品一覧クラス
 *
 * @export SelectionListInfo
 * @class SelectionListInfo
 */
export class SelectionListInfo {
  constructor(
    // チェックボックス
    public check: boolean = false,
    // 特集コード
    public featureCode: string = null,
    // 特集名
    public featureName: string = null,
    // フォーマット特集
    public formatFeature: string = null,
    // 部門コード
    public classCode: string = null,
    // 部門名
    public classNameKanji: string = null,
    // フォーマット部門
    public formatClass: string = null,
    // 中分類コード
    public middleClassCode: string = null,
    // 中分類名
    public middleClassNameKanji: string = null,
    // フォーマット中分類
    public formatMiddleClass: string = null,
    // Pコード
    public pCode: string = null,
    // 商品名
    public guideGoodsName: string = null,
    // 規格名
    public guideStandardName: string = null,
    // 価格パターン
    public pricePattern: string = null,
    // 価格パターン編集有無
    public isChangedPricePattern: string = null,
    // 今回供給価格
    public thisTimeSupplyPrice: string = null,
    // 供給価格（通常）
    public supplyPriceStandard: string = null,
    // 供給価格（特価1）
    public supplyPriceSpecial1: string = null,
    // 供給価格（特価2）
    public supplyPriceSpecial2: string = null,
    // 今回供給価格編集有無
    public isChangedSupplyPrice: string = null,
    // 仕入価(今回仕入価格)
    public thisTimeCostPrice: string = null,
    // 単品仕入価格（通常）
    public costPriceStandard: string = null,
    // 単品仕入価格（特価1）
    public costPriceSpecial1: string = null,
    // 単品仕入価格（特価2）
    public costPriceSpecial2: string = null,
    // 今回仕入価格編集有無
    public isChangedCostPrice: string = null,
    // 計画数(予測)
    public predictPlanNum: string = null,
    // 計画数
    public planNum: string = null,
    // 計画数編集有無
    public isChangedPlanNum: string = null,
    // 計画供給高
    public planSupplyBudget: string = null,
    // 表示用：計画供給高（千円）
    public dispPlanSupplyBudget: string = null,
    // 計画供給高編集有無
    public isChangedPlanSupplyBudget: string = null,
    // GPR
    public gpr: string = null,
    // タグ
    public tagName: string = null,
    // 備考
    public remarks: string = null,
    // 選定担当区分
    public selectorType: string = null,
    // バイヤー選定依頼ID
    public buyerRequestId: string = null,
    // アイテムコード
    public itemCode: string = null,
    // バイヤー承認フラグ
    public buyerApprovalFlag: string = null,
  ) {}
}

